import WeatherHealthBadge from "../WeatherHealthBadge";
import { formatDateTime } from "../../../users/adminUserFormatters";
import {
  formatFrameAge,
  resolveRenderedTrustBadge,
  resolveSourceLabel,
} from "../../../../../../utils/radarHealthAdminUtils";

function SummaryDetail({ label, value }) {
  if (value == null || value === "") {
    return null;
  }

  return (
    <p className="weather-radar-health-card__detail">
      <span className="weather-radar-health-card__detail-label">{label}</span>
      <span>{value}</span>
    </p>
  );
}

const WeatherRadarHealthSummaryCards = ({ health }) => {
  if (!health) {
    return null;
  }

  const bart = health.sources?.ideamBart;
  const rainViewer = health.sources?.rainViewer;
  const renderedLabel = resolveSourceLabel(health.renderedSource, health);
  const trustBadge = resolveRenderedTrustBadge(health);

  const currentStatus =
    health.fallbackActive || health.status === "fallback_active"
      ? "fallback_active"
      : health.status;

  return (
    <section className="admin-dashboard__kpis weather-radar-health-summary">
      <div className="admin-dash__kpi-card weather-radar-health-card">
        <span className="admin-dash__kpi-label">Current Radar</span>
        <span className="admin-dash__kpi-value">{renderedLabel}</span>
        <span className={`weather-radar-health-card__trust weather-radar-health-card__trust--${trustBadge.toLowerCase().replace(/\s+/g, "-")}`}>
          {trustBadge}
        </span>
        <WeatherHealthBadge status={currentStatus} />
      </div>

      <div className="admin-dash__kpi-card weather-radar-health-card">
        <span className="admin-dash__kpi-label">Official Source</span>
        <span className="admin-dash__kpi-value">{bart?.sourceLabel || "IDEAM Imagen Compuesta"}</span>
        <SummaryDetail label="Latest frame age" value={formatFrameAge(bart?.latestFrameAgeMinutes)} />
        <SummaryDetail
          label="Latest renderable"
          value={bart?.latestRenderableFrameTime ? formatDateTime(bart.latestRenderableFrameTime) : "—"}
        />
        <WeatherHealthBadge status={bart?.status} />
      </div>

      <div className="admin-dash__kpi-card weather-radar-health-card">
        <span className="admin-dash__kpi-label">Fallback</span>
        <span className="admin-dash__kpi-value">{rainViewer?.sourceLabel || "RainViewer backup"}</span>
        <SummaryDetail
          label="Availability"
          value={rainViewer?.reachable ? "Reachable" : rainViewer ? "Unreachable" : "—"}
        />
        <SummaryDetail
          label="Fallback active"
          value={health.fallbackActive ? "Yes" : "No"}
        />
        <WeatherHealthBadge status={rainViewer?.status} />
      </div>

      <div className="admin-dash__kpi-card weather-radar-health-card">
        <span className="admin-dash__kpi-label">Cache</span>
        <SummaryDetail label="Cached frames" value={bart?.cachedFrameCount ?? "—"} />
        <SummaryDetail label="Renderable frames" value={bart?.renderableFrameCount ?? "—"} />
        <SummaryDetail label="Invalid frames" value={bart?.invalidFrameCount ?? "—"} />
        <SummaryDetail
          label="Last sync"
          value={bart?.lastSyncAt ? formatDateTime(bart.lastSyncAt) : "—"}
        />
      </div>
    </section>
  );
};

export default WeatherRadarHealthSummaryCards;
